var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNotice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-notice") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Doshboard-beta-messaging",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-375.000000, -144.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Beta-messaging",
    transform: "translate(352.000000, 118.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-notice",
    transform: "translate(18.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "spacing",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,24 C10.0294373,24 6,19.9705627 6,15 C6,10.0294373 10.0294373,6 15,6 C19.9705627,6 24,10.0294373 24,15 C24,19.9705627 19.9705627,24 15,24 Z",
    id: "Combined-Shape",
    stroke: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-Copy-2",
    fill: "#4C4C4C",
    x: 14,
    y: 19,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Rectangle-2",
    fill: "#4C4C4C",
    points: "14.6666667 17 14 9 16 9 15.3333333 17"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotice);
export default __webpack_public_path__ + "static/media/ic-notice.ab8827f4a48fb899b9e2ef913d9031bf.svg";
export { ForwardRef as ReactComponent };